import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import OverflowTooltip from '@adsk/bim360-matrix-react-overflow-tooltip';

/**
 * HeaderCell for MatrixTable
 */
class TableHeaderCell extends React.PureComponent {
  render() {
    const { className, column, container } = this.props;
    const children = this.props.children !== undefined ? this.props.children : column.title;

    return (
      <OverflowTooltip
        className={className}
        tooltipClassName="MatrixTable__tooltip-popover"
        container={container}
        theme={Tooltip.Themes.DARK}
        autoTipOnEllipsis={!this.props.children}
        singleLine={false}
      >
        {children}
      </OverflowTooltip>
    );
  }
}

TableHeaderCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  column: PropTypes.object,
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

export default TableHeaderCell;
